import { combineReducers } from 'redux';
import { miscReducer } from './miscReducer';
import { prvkyReducer } from './prvkyReducer';
import { filteringReducer } from './filteringReducer';
import { menuReducer } from './menuReducer';

const reducers = combineReducers({
    allPrvky: prvkyReducer,
    miscDicts: miscReducer,
    filtStates: filteringReducer,
    menuSelection: menuReducer
})

export default reducers